import { FC } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Form from '~/components/WizardForm';
import { scrollToFirstError } from '~/components/Form';
import {
  additionalInfo,
  additionalInfoComment,
} from '~/components/views/ShareholdersMultiple/BeneficialOwnerAdditionalInformation';
import { Stage } from '~/types/Application';
import buildNamePath from '~/utils/buildNamePath';
import ShareTables from './ShareTables';
import ShareholdersProofs from './ShareholdersProofs';

const n = buildNamePath('shareholders');

const ShareholdersMultiple: FC = () => {
  const { t } = useTranslation('ksaApplication');

  const [form] = Form.useForm();

  return (
    <Container className="ShareholdersMultiple">
      <Form
        stage={Stage.ksaApplication}
        form={form}
        payloadKey="shareholders"
        handleDraftDataBeforeSave={(v) => v}
        // scrollToFirst works incorrectly with file inputs https://github.com/ant-design/ant-design/issues/28869
        scrollToFirstError={false}
        onFinishFailed={(errorInfo) => {
          if (Array.isArray(errorInfo.errorFields)) {
            const { errorFields } = errorInfo;
            if (errorFields.find((errorItem) => errorItem.name.includes(additionalInfo))) {
              form.scrollToField(additionalInfoComment, scrollToFirstError);
            } else {
              form.scrollToField(errorFields[0].name, scrollToFirstError);
            }
          }
        }}
      >
        <ShareholdersProofs />
        <Typography.Title level={4}>{t('Review shareholders').toUpperCase()}</Typography.Title>
        <Typography.Paragraph>
          {t('Please review all shareholders of your company.')}
        </Typography.Paragraph>

        <ShareTables />

        <Form.Item hidden name={n('authorizedRepresentative')} />
        <Form.Item hidden name={n('individuals')} />
        <Form.Item hidden name={n('beneficialOwners')} />
        <Form.Item hidden name={n('businesses')} />
      </Form>
    </Container>
  );
};

// const n = (namePath: string | string[]) => [shareholdersKey].concat([namePath].flat());

// const copyMemorandumOrPartnership = 'Upload Copy of Memorandum of Association or Partnership deed';
// const getProofDocumentOptions = () => [
//   {
//     label: i18n.t('Shareholders are listed in company license', { ns: 'fillApplication' }),
//     value: 'Shareholders are listed in company license',
//   },
//   {
//     label: i18n.t(copyMemorandumOrPartnership, { ns: 'fillApplication' }),
//     value: copyMemorandumOrPartnership,
//   },
// ];

const Container = styled.div`
  .ShareholdersMultiple-Collapse {
    margin: -16px;
    margin-bottom: 32px;

    .ant-select-selector {
      max-width: calc(100vw - ${16 * 2 + 8 * 2}px);
    }
  }

  .ShareholdersMultiple-CheckboxItem {
    width: 100%;
    margin-bottom: 16px;
  }
`;

export default ShareholdersMultiple;
